import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Loading } from "@/components/common";
import { CompanyForm } from "@/components/CompanyForm";
import { LogoUpload } from "@/components/LogoUpload";
import { NotaDesigner } from "@/components/NotaDesigner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function CompanySettings() {
  const { can, reload } = useAuth();
  const editable = can("company:write");
  const [c, setC] = useState(null);
  useEffect(() => {
    api.get("/company").then((r) => setC(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  const save = async (body) => {
    try {
      const { data } = await api.put("/company", body);
      setC(data);
      reload();
      toast.success("Pengaturan perusahaan disimpan");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader sheet="SHEET 09" title="Pengaturan Perusahaan" subtitle={editable ? "Profil, logo, kode nota, dan aturan perhitungan." : "Hanya pemilik yang dapat mengubah pengaturan."} />
      {!c ? <Loading /> : (
        <Tabs defaultValue="profile">
          <TabsList>
            <TabsTrigger value="profile" data-testid="tab-company-profile">Profil & Aturan</TabsTrigger>
            <TabsTrigger value="design" data-testid="tab-nota-design">Desain Nota</TabsTrigger>
          </TabsList>
          <TabsContent value="profile" className="mt-4">
        <div className="grid lg:grid-cols-[1fr_280px] gap-6 bg-white border border-slate-300 rounded-sm p-5 fade-up">
          <CompanyForm initial={c} onSubmit={save} disabled={!editable} />
          <div>
            <div className="text-xs font-semibold text-slate-700 mb-2">Logo Perusahaan</div>
            <LogoUpload logo={c.logo} uploadUrl="/company/logo" disabled={!editable} onUploaded={(logo) => { setC((s) => ({ ...s, logo })); reload(); }} />
          </div>
        </div>
          </TabsContent>
          <TabsContent value="design" className="mt-4">
            <div className="bg-white border border-slate-300 rounded-sm p-5 fade-up">
              <NotaDesigner company={c} disabled={!editable} onSaved={(t) => { setC(t); reload(); }} />
            </div>
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}
